import type {AppBreadcrumbProps} from "../../types";
import React, {Fragment} from "react";
import {useLocation} from "react-router-dom";

export const formatText = (path)=> {
    const segments = path.split("/").filter(Boolean);

    return segments.map((segment, index) => {
        const label = segment.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");

        return (
            <Fragment key={index}>
                {index !== 0 && (
                    <i className="pi pi-chevron-right mx-2" />
                )}
                <span>{label}</span>
            </Fragment>
        );
    });
}

const AppBreadcrumb = (props: AppBreadcrumbProps) => {
    const pathname = useLocation().pathname;
    const breadcumb = formatText(pathname);


    return (
        <div className={props.className}>
            <nav className="layout-breadcrumb">
                <div className="flex align-items-center">
                    {pathname==="/" ? "Dashboard" : breadcumb}
                </div>
            </nav>
        </div>
    );
};

export default AppBreadcrumb;
